export default __webpack_public_path__ + "static/media/KIRANPAL SINGH CHAWALA.23bb20db.jpg";